import Vue from 'vue';
import axios from 'axios';


// axios.defaults.baseURL = 'http://'+window.location.host+'/fangcang-gdp-web';
axios.defaults.baseURL = '/fangcang-gdp-web';
Vue.prototype.$ajax = axios;

export default{
	getMerchant(store) {
		var _this = this;
		axios.post('/home/getMerchant')
			.then(function(response) {
				let res = response.data
				if(res.result == 1) {
					store.commit('setItemNum',res.model);
				}
				// 响应成功回调
			}, function(response) {
				// 响应错误回调
			});
	},
	
}



// WEBPACK FOOTER //
// ./docs/store/actions.js